module.exports = __webpack_public_path__ + "static/media/hall-CSS.41815947.svg";